<template>
    <div id="app">

        <nav class="menu">
            <div class="container">
                <div class="row">
                    <template v-if="varIsSmallMedia === false">
                        <div class="four columns" style="margin-top: 1em; margin-bottom: 1em;">
                            <router-link to="/" exact tag="span"  class="logo-route-link-mobil" exact-active-class="logo-route-link-mobile">Nikolai&nbsp;Müller</router-link>
                            <br>
                            <span class="logo-line2-mobil">Softwareentwickler</span> <!-- color:#42b983 -->
                        </div>
                        <div class="eight columns">
                            <ul class="menu" style="font-family:Jura; margin-top: 16px;">
                                <!-- <router-link to="/" exact tag="li" style="margin-left:1px;">Home</router-link> -->
                                <!-- <router-link to="/AboutMe" tag="li">Über Mich</router-link> -->
                                <router-link to="/Links" tag="li" style="margin-left:1px;">Links</router-link>
                                <router-link to="/MakingOf" tag="li">Making-Of</router-link>
                                <!-- <router-link to="/contact" tag="li">Kontakt</router-link> -->
                                <!-- <router-link to="/blog" tag="li">Blog</router-link> -->
                                <!-- <router-link to="/PoCs" tag="li">[PoC's]</router-link> -->
                                <router-link v-if="canLogin && this.current.user !== null" to="/Logoff" tag="li">
                                    <small>Abmelden:&nbsp;<span style="color:#42b993;">{{this.current.user.DisplayName.toString()}}</span></small>
                                </router-link>
                                <router-link v-if="canLogin && this.current.user === null" to="/Login" tag="li">Anmelden</router-link>
                            </ul>
                        </div>
                    </template>
                    <template v-else>
                        <div class="one-half column" style="width:50%; margin-top: 8px;">
                            <router-link to="/" exact tag="span"  class="logo-route-link-mobil" exact-active-class="logo-route-link-mobile">Nikolai&nbsp;Müller</router-link>
                            <br>
                            <span class="logo-line2-mobil" style="">Softwareentwickler</span> <!-- color:#42b983 -->
                        </div>
                        <div class="one-half column" style="width:50%; margin-top: 8px;">
                            <span v-on:click="isMenuFlyout = !isMenuFlyout" class="button u-pull-right" style="font-family:Jura; color:#cccccc; font-size:0.9em">Menu</span>
                        </div>
                        <div>
                            <ul v-show="isMenuFlyout === true" class="menuFlyout" style="font-family:Jura; border: 1px solid silver; margin: 2px;">
                                <router-link to="/" exact tag="li">Home</router-link>
                                <!-- <router-link to="/AboutMe" tag="li">Über Mich</router-link> -->
                                <router-link to="/Links" tag="li">Links</router-link>
                                <router-link to="/MakingOf" tag="li">Making-Of</router-link>
                                <!-- <router-link to="/contact" tag="li">Kontakt</router-link> -->
                                <!-- <router-link to="/blog" tag="li">Blog</router-link> -->
                                <!-- <router-link to="/PoCs" tag="li">[PoC's]</router-link> -->
                                <!-- <li><hr style="margin-left: 0px; margin-right: 0px; margin-top:18px; margin-bottom:0px;"></li> -->
                                <router-link v-if="canLogin && this.current.user !== null" to="/Logoff" tag="li">
                                    <small>Abmelden:&nbsp;<span style="color:#42b993;">{{this.current.user.DisplayName.toString()}}</span></small>
                                </router-link>
                                <router-link v-if="canLogin && this.current.user === null" to="/Login" tag="li">Anmelden</router-link>

                                <li><hr style="margin-left: 0px; margin-right: 0px; margin-top:18px; margin-bottom:0px;"></li>

                                <router-link to="/Impressum" tag="li"><small>Impressum</small></router-link>
                                <router-link to="/Datenschutz" tag="li"><small>Datenschutz</small></router-link>
                            </ul>
                        </div>
                    </template>
                </div>
            </div>
            <div class="red-top-line" style="height:1px;"></div>
        </nav>

        <div class="bg-nm calcHeight"><!--  style="padding-bottom: 70%;" -->
            <router-view/>
        </div>

        <nav class="menu">
            <div class="red-bottom-line"></div>
            <div class="container">
                <div class="row">
                    <div class="twelve columns">
                        <ul class="menu" style="font-family:Jura;">
                            <router-link to="/Impressum" tag="li" style="margin-left:1px;"><small>Impressum</small></router-link>
                            <router-link to="/Datenschutz" tag="li"><small>Datenschutz</small></router-link>
                            <li v-if="varIsSmallMedia === false" style="text-shadow: 0 0; color: #888888;">
                                <small>&lt;<a href="https://github.com/vuejs/vue/tree/v2.6.11" target="_blank">Vue.js v.{{vueVersion}}</a>&gt;</small>
                            </li>
                            <li v-if="varIsSmallMedia === false" style="text-shadow: 0 0; color: #888888;"><small>&copy; 2018..2021 Nikolai Müller</small></li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>

    </div>
</template>

<script>
import Vue from 'vue'

export default {
    name: 'App',
    beforeMount: function () {
        window.addEventListener('resize', this.onResize, false)
        this.onResize(null)
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.onResize)
    },
    mounted: function () {
        this.$on('user_loggedin', this.onUserLoggedin)
    },
    data: function () {
        return {
            vueVersion: Vue.version || '???',
            varIsSmallMedia: false,
            isResizing: false,
            isMenuFlyout: false,
            canLogin: window.location.protocol === 'https:' || window.location.hostname === 'localhost',
            current: {
                user: null,
                clientId: null,
                sidHex: null
            }
        }
    },
    methods: {
        onResize: function (event) {
            // console.log('on:Resize event: this: ')

            /* ---------------------------------------------------------
            SEE:   https://www.reddit.com/r/vuejs/comments/6vffp1/vuejs_media_queries/?st=jcz71h6z&sh=5d7bfad4
            and:   https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
            ---------------------------------------------------------
            Skeleton media queries:   http://getskeleton.com/#queries
                Desktop HD: 1200px  @media (min-width: 1200px) {}
                Desktop:    1000px  @media (min-width: 1000px) {}
                Tablet:      750px  @media (min-width: 750px) {}
                Phablet:     550px  @media (min-width: 550px) {}
                Mobile:      400px  @media (min-width: 400px) {}
            --------------------------------------------------------- */

            let self = this
            const delayMs = 250

            // eslint-disable-next-line
            const treshholdDesktopHD = '(min-width: 1200px)'
            // eslint-disable-next-line
            const treshholdDesktop = '(min-width: 1000px)'
            // eslint-disable-next-line
            const treshholdTablet = '(min-width: 750px)'
            // eslint-disable-next-line
            const treshholdPhablet = '(min-width: 550px)'
            // eslint-disable-next-line
            const treshholdMobile = '(min-width: 400px)'

            if (self.isResizing === false) {
                self.isResizing = true
                window.setTimeout(function () {
                    // console.log('on:Resize doResize / delayed: ')
                    if (window.matchMedia(treshholdPhablet).matches) {
                        // the viewport is at least 400 pixels wide
                        self.varIsSmallMedia = false
                    } else {
                        // the viewport is less than 400 pixels wide
                        self.varIsSmallMedia = true
                    }
                    self.isResizing = false
                }, delayMs)
            }
        },
        onUserLoggedin: function (userDetails) {
            // console.log(`App.onLoggedIn: userDetails: `, userDetails)
            this.current.user = userDetails
            // $$$ TODO: Cryptographical Access-Token needed here !!

            // redirect home
            this.$router.push('/')
        }
    }
}
</script>

<style>
@import './assets/normalize.css';
@import './assets/skeleton.css';
@import './assets/nunito.css';
@import './assets/jura.css';

.calcHeight {
    min-height: -moz-calc(100vh - 8em);
    min-height: -webkit-calc(100vh - 8em);
    min-height:   calc(100vh - 8em);
}
body {
    font-family: /* see: https://www.smashingmagazine.com/2015/11/using-system-ui-fonts-practical-guide/ -- and Bootstrap 4 - content/reboot */
    'Nunito', /* 'Nunito', */ /* 'Jura', */
    /* 1 */ -apple-system, BlinkMacSystemFont,
    /* 2 */ "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    /* 3 */ "Helvetica Neue", sans-serif;
    font-size: 12pt; /* 10.5pt; */
    font-weight: 300;
    margin: 0px;
    padding: 0px;
    color: #333333;
    background-color:  #333333; /* #ffffff; */
    /* */
    line-height: 1.3em; /* 1.6; */
}
#app {
    /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    margin: 0px;
    padding: 0px;
    height:100%;
}
h1, h2, h3, h4, h5, h6 {
    font-weight: 200;
}
h1 { color: #fff; /* text-shadow: 2px 2px 1px #fcaa5800; */ }
h2 { color: #fff; /* text-shadow: 2px 2px 1px #fcaa5880; */ }
h3 { color: #fff; /* text-shadow: 2px 2px 1px #fcaa5880; */ }

.red-top-line {
    background-color: #e00056;
    background: -webkit-linear-gradient(left, #f880ae60 30%, #e00056 77%);
    background: linear-gradient(to right, #f880ae60 30%, #e00056 77%);
    height:1px;
}
.red-bottom-line {
    background-color: #e00056;
    background: -webkit-linear-gradient(left, #f880aec0 31%, #e00056 59%);
    background: linear-gradient(to right, #f880aec0 31%, #e00056 59%);
    height: 1px;
}

/* Logo */
.logo-line1-mobil {
    font-family:Jura;
    color:#cccccc;
    font-size:1.26em;
    font-weight:600;
    border-bottom: 1px solid #e00056;
}
.logo-route-link-mobil {
    font-family:Jura !important;
    color:#cccccc !important;
    font-size:1.26em !important;
    font-weight:600 !important;
    text-shadow: none !important;
    border-bottom: 1px solid #e00056 !important;
    cursor: pointer;
}
.logo-delim-mobil { border-bottom: 1px solid #e00056 !important; }
.logo-line2-mobil {
    font-family:Jura;
    color:#42b993;
    font-size:0.9em;
    font-weight:500;
}

.logo-line1-hd {
    text-shadow: 3px 3px 0.4px #40404030;
    font-family:Jura, /* 1 */ -apple-system, BlinkMacSystemFont,
    /* 2 */ "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    /* 3 */ "Helvetica Neue", sans-serif;
    font-size:2.06em;
    margin:0px;
    font-weight:600;
    color:#404040;
}
.logo-route-link-hd {
    text-shadow: 3px 3px 0.4px #40404030 !important;
    font-family:Jura !important;
    font-size:1em !important;
    margin:0px !important;
    font-weight:600 !important;
    color:#404040 !important;
    border-bottom: 1px solid #ff0060;
    cursor: pointer;
}
.logo-delim-hd {
    border-bottom: 1px solid #ff0060;
}
.logo-line2-hd {
    font-family:Jura;
    font-weight:500;
    font-size:1.5em;
    margin:0px;
    color:#42b993; /* #42b993 */
    text-shadow:none;
    text-shadow: 3px 3px 0px #42b99338;
}
/* Logo */

/* *** Menu relevant *** */

a {
    /* color: #ff0060; */
    /* color: #eb005a; */
    color: #e00056;
    /* vuejs:: color: #42b983; */
    text-decoration: unset;
}
a:hover {
    color: #9b0031;
    /* text-shadow: 0px 0px 2px #9b0031; */
}
.router-link-active {
    /* color: #ffffff;
    text-shadow: 2px 2px 8px #ffb584 ; */
    color: #ff0060;
    text-shadow: 8px 8px 0px #ff006270 , 0px 0px 1px #ff0062 ;   /* , -5px -4px 0px #ff006230, 0px 0px 12px #ffffff */
    font-size:1.2em;
    font-weight: lighter;
}
.menu {
    /* color: #ff0060;
    text-shadow: 0px 0px 12px #e6aeae ; */
    /* color: #ffffff;
    text-shadow: 2px 2px 8px #ffb584 ;*/
    color: #bbbbbb;
    background-color: #333333;
    /* font-size:1.15em; */
    font-weight:lighter;
}
ul.menu {
    list-style-type: none;
    padding-top: 12px;
    padding-bottom: 14px;
    margin: 0;
}
ul.menu > li {
    display: inline-block;
    margin: 0 10px;
    font-size:1.2em;
    /*-- font-weight:bold; */
    cursor: pointer;
}
/* *** */
.menuFlyout {
    position:absolute;
    right: 1.2em;
    top: 4em;
    z-index: 12;
    width:43%;
    border-radius: 4px;
    color: #bbbbbb;
    background-color: #333333;
    /* font-size:1.15em; */
    font-weight:lighter;
}
ul.menuFlyout {
    list-style-type: none;
    padding-top: 4px;
    padding-bottom: 4px;
    margin: 0;
    box-shadow: 1px 0px 2px 2px #aca7a78a;
}
ul.menuFlyout > li {
    display:block;
    margin: 8px 14px;
    font-size:1.1em;
    /*-- font-weight:bold; */
    cursor: pointer;
}

/* Neues design */
.distance {
    padding-top: 2em;
}
.bg-nm { /* Hintergrund Bild */
    /* BG Image
    padding-top: 2em;
    background-image: url("../assets/Nikolai-Mueller-2-bw-q-1024.jpg");
    background-repeat: no-repeat;
    background-size: 100%; min-height: 1024px;
    background-color: grey;
    color: white; font-weight: bolder;
    text-shadow: 0px 0px 2px #202020;
    */
    /* Heller BG Verlauf
    -webkit-background: linear-gradient(to bottom, #c0c0c0 31%, #e8e8e8 59% 100%);
    background: linear-gradient(to bottom, #c0c0c0 31%, #e8e8e8 59%);
    */
    /* Dunkler BG Verlauf */
    background-color: #607080;
    -webkit-background: linear-gradient(top, #303030, #607080);
    background: linear-gradient(to bottom, #303030 31%, #607080 59%);
    /* font-weight: bolder; */
    color: white;
}
.link-color { color: #fcaa58; }
.link-hover-color { color: #ff0060; }
a { color: #fcaa58; font-weight:bolder; } /* #ff8000 */ /* #80ff80 */
a:hover { color: #ff0060; text-decoration: underline; }
/* BG Image
a {
    font-weight:bolder;
    text-shadow: 0px 0px 1px #ff0060;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue